/* eslint-disable */
import { AppService } from './AbstractService';

export default class BankService extends AppService {
  public async getAllBanks() {
    return this.makeRequest('GET', '/banks');
  }

  getConfig() {
    return this.makeRequest('GET', '/banks/players/config');
  }
}
